import { Effect, pipe } from 'effect';

// Constants
import { END_POINTS } from '@/constants/endpoint';

// Utils
import { handleActionError } from '@/utils/errorHandlers';

// Services
import { httpClient } from '@/services/http';

// Types
import { StatisticsType } from '@/types/api';
import { RequestConfig } from '@/types';

const getStatistics = async (options?: { requestConfig?: RequestConfig }) =>
  Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: async () => {
          const response = await httpClient<StatisticsType>(
            END_POINTS.GET_STATISTICS,
            options?.requestConfig,
          );

          return response;
        },
        catch: (error) => handleActionError(error),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );

export { getStatistics };
